import React from 'react'
import API from '../Utils/api'
import { getUsuarioFromStorage } from '../Utils/usuarioHelper'
import Cleave from 'cleave.js/react'
import * as $ from 'jquery'
import * as yup from 'yup'
import MasterTemplate from "./MasterTemplate";
import { Link } from 'react-router-dom';


const initialFormValues = {
    form: {
        nome: '',
        telefone: '',
        cpf: ''
    }
}

const schema = yup.object().shape({
    nome: yup
        .string()
        .label('Nome')
        .required('Nome é obrigatório.')
        .trim(),
    telefone: yup
        .string()
        .label('Telefone')
        .required('Telefone é obrigatório.')
        .trim(),
    cpf: yup
        .string()
        .label('CPF')
        .required('CPF é obrigatório.')
        .trim()
})

export class MasterGerenciarCambistas extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props)
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            cambistas: [],
            errors: [],
            form: {
                nome: '',
                telefone: '',
                cpf: ''
            },
            cleaves: {
                cpf: null,
                telefone: null
            },
            filteredList: []
        }
        this.deletacambista = this.deletacambista.bind(this)
    }

    componentDidMount() {
        this.listarcambistas()
    }

    cpfInit = (cleave) => {
        this.setState(state => {
            return {
                ...state,
                cleaves: {
                    ...state.cleaves,
                    cpf: cleave
                }
            }
        })
    }

    telefoneInit = (cleave) => {
        this.setState(state => {
            return {
                ...state,
                cleaves: {
                    ...state.cleaves,
                    telefone: cleave
                }
            }
        })
    }

    listarcambistas = async (e) => {
        try {
            const { user } = this.state
            const response = await API.post('/api/usuarios/listar-todos-cambistas', {
            })

            this.setState({ cambistas: response.data.sort(this.compararNome) })
            this.setState({filteredList: this.state.cambistas})
        } catch (err) {
            console.log(err)
        }
    }

    async listarCambistas2 (e) {
        try {
            const response = await API.post('/api/usuarios/listar-todos-cambistas-l2', {
                spell: e.target.value
            })
            if(response){
              this.setState({ cambistas: response.data.sort(this.compararEmail)})
              this.setState({filteredList : this.state.cambistas})
            }
        } catch (err) {
            console.log(err)
        }
      }

    handleRequiredCleaveLength = event => {
        const minLength = event.target.dataset.length
        const { name, rawValue } = event.target

        if (rawValue && rawValue.length < minLength) {
            this.setState(state => {
                return {
                    ...state,
                    form: {
                        ...state.form,
                        [name]: ''
                    }
                }
            })
            this.state.cleaves[name].setRawValue('')
        }
    }

    handleChangeCadastroRapido = event => {
        const { name, value } = event.target
        if (name) {
            this.setState(state => {
                return {
                    ...state,
                    form: {
                        ...state.form,
                        [name]: value
                    }
                }
            })
        }
    }

    resetForm = () => {
        this.setState({ form: { ...initialFormValues } })
        for (let key in this.state.cleaves) {
            this.state.cleaves[key].setRawValue('')
        }
    }

    hasFormError = (label = '') => {
        const errors = this.state.errors

        if (errors.length > 0) {
            const hasError = errors.filter(item => item.path === label)
            return hasError.length > 0
        }

        return false
    }

    getFormError = (label = '') => {
        const errors = this.state.errors

        if (errors.length > 0) {
            const hasError = errors.filter(item => item.path === label)
            return hasError
        }

        return []
    }

    cadastrarcambista = async () => {
        try {
            await schema.validate(this.state.form, { abortEarly: false })

            const dados = {
                ...this.state.form,
                tutorId: this.state.user._id
            }
            const response = await API.post('/api/usuarios/fast', dados)

            const { error } = response.data
            if (error) throw new Error(error)

            const update = this.state.cambistas
            update.unshift(response.data)
            this.setState(state => {
                return {
                    ...state,
                    cambistas: update,
                }
            })
            $('#modalCadastroRapido').modal('hide')

            setTimeout(() => alert('Usuário cadastrado com sucesso.'), 1000)

            this.resetForm()
        } catch (error) {
            if (error.name === 'ValidationError') {
                this.setState(state => {
                    return {
                        ...state,
                        errors: error.inner
                    }
                })
            } else {
                alert(error.message)
            }
        }
    }

    async deletacambista(e){
        try {
            const response = await API.post('/api/usuarios/deleta',
             { id: e.target.name
            })
            alert("cambista removido!")
            window.location.reload()
        } catch (err) {
            console.log(err)
        }

    }


    compararNome (a, b) {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
          return 1;
        }
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
          return -1;
        }

        return 0
      }

    compararEmail (a, b) {
        if (a.email.toLowerCase() > b.email.toLowerCase()) {
          return 1;
        }
        if (a.email.toLowerCase() < b.email.toLowerCase()) {
          return -1;
        }

        return 0
      }

      searchName(e){
        var filteredList  = this.state.cambistas.filter(usuario => 
          {
            if(usuario != undefined && usuario.nome.toLowerCase().includes(e.target.value.toLowerCase())){
            return usuario;
          }
        }
        )
        
        this.setState({filteredList : filteredList})
    }

    render() {

        return (
            <MasterTemplate label="Gerenciar cambistas">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card strpied-tabled-with-hover">
                                <div className="card-header ">
                                <Link to="/master-cadastro-cambista"
                                          className="btn btn-success btn-fill float-md-right float-lg-right">Cadastrar</Link>
                                    <h4 className="card-title">Acompanhe seus cambistas</h4>
                                    <p className="card-category">Informações dos cambistas</p>
                                    {/* <span className="text-dark font-weight-bold">Total de cambistas:</span> <span className="text-danger font-weight-bold"> {this.state.cambistas.length}</span> */}
                                </div>
                                <div className="card-body table-full-width table-responsive">
                                <div className="row pl-5 pr-5 justify-content-center">
                                         <input className="ml-5 w-50 form-control" placeholder="Filtrar a lista de cambistas por email" onChange={this.listarCambistas2.bind(this)}></input>

                                        {/* <input className="form-control w-50" placeholder="busca rapida..." onChange={this.searchName.bind(this)}></input> */}
                                    </div>
                                    <table className="table table-hover table-striped">
                                        <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>Gerente</th>
                                            <th>Email</th>
                                            <th>Rua</th>
                                            <th>Bairro</th>
                                            <th>Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.cambistas && this.state.filteredList.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{item?.nome}</td>
                                                    <td>{item?.tutorId?.nome}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.endereco}</td>
                                                    <td>{item?.bairro}</td>
                                                    <td>{item?.status? "Ativo"  : "Bloqueado"}</td>
                                                    <td className="w-100 d-flex justify-content-center">
                                                        <div className="dropdown">
                                                            <Link to="#" id={`dLabel_${index}`}
                                                               type="button" data-toggle="dropdown"
                                                               aria-haspopup="true"
                                                               aria-expanded="false">
                                                                <i className="fas fa-ellipsis-h"></i>
                                                            </Link>
                                                            <div className="dropdown-menu"
                                                                 aria-labelledby={`dLabel_${index}`}>
                                                                <Link className="dropdown-item"
                                                                      to={`/master-cadastro-cambista?id=${item?._id}`}>Editar</Link>
                                                                <Link to="#" className="dropdown-item" name={item?._id}
                                                                   onClick={this.deletacambista}>Deletar
                                                                    </Link>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MasterTemplate>
        )
    }
}

export default MasterGerenciarCambistas